//libs
import React,{Component} from "react";
import {connect} from "react-redux";
//components
import Loading from "../../UI_Elements/Loading";
//other
import {setTrue} from "../../../actions/refresh";
import {post as createStation, put as updateStation, getGroupTypes} from "../../../actions/stations";
import {post as createWheelChanger, put as updateWheelChanger} from "../../../actions/wheelChangers";



class CreateGroupForm extends Component {

    constructor(props) {
        super(props);

        let id,name,retailerId,address,city,postalCode,groupType,phoneNumber,stationId,desiredFriction,desiredSpikes,email,deliverySchedule;
        id=name=retailerId=address=city=postalCode=groupType=phoneNumber=stationId=email="";
        desiredFriction = desiredSpikes = deliverySchedule = 0;

        this.props.getGroupTypes();

        if (typeof(props.group)!=="undefined"){
            const group = props.group;

            id = group.id;
            name = group.name;
            retailerId = group.retailerId;
            address = group.address;
            city = group.city;
            postalCode =group.postalCode;
            phoneNumber=group.phoneNumber;
            stationId = group.stationId;
            groupType = group.type;
            email = group.email;
            deliverySchedule = group.deliverySchedule;
            if (typeof(group.desiredFriction)!=="undefined"){
                desiredFriction = group.desiredFriction;
                desiredSpikes = group.desiredSpikes
            }
            let x = null;
            if (group && group.type){
                for(x in this.props.groupTypes){
                    if (this.props.groupTypes[x].id===group.type){
                        groupType = this.props.groupTypes[x].name;
                    }
                }
            }

            if (typeof(groupType)==="undefined" || groupType===""){
                groupType="Skiftesverkstad";
            }

        }


        this.state = {
            id:id ? id :"",
            name: name ? name :"",
            retailerId: retailerId ? retailerId :"",
            address: address ? address : "",
            city: city ? city : "",
            postalCode: postalCode ? postalCode:"",
            groupType: groupType ? groupType : "",
            phoneNumber: phoneNumber ? phoneNumber :"",
            stationId: stationId ? stationId : "",
            desiredFriction :desiredFriction ? desiredFriction :"",
            desiredSpikes :desiredSpikes ? desiredSpikes :"",
            email:email ? email : "",
            deliverySchedule:deliverySchedule ? deliverySchedule : ""
        };

    }

    validateForm() {
        // return this.state.email.length > 0;
        if (this.state.name.length===0){
            return false;
        }
        if (this.state.retailerId.length===0){
            return false;
        }
        if (typeof(this.state.groupType)==="undefined" &&  this.state.groupType==="Ingen"){
            return false;
        }
        return true;
    }

    handleChange = event => {
        event.preventDefault();
        event.stopPropagation();

        var value = event.target.value;
        var oldValue = this.state[event.target.name];

        switch(event.target.name){

            case "desiredFriction":
                oldValue = parseInt(oldValue,10);
                if (!Number.isInteger(oldValue)){
                    oldValue=0;
                }
                value=parseInt(value,10);
                if (!Number.isInteger(value)){
                    value = oldValue;
                }

                if (parseInt(value,10)<0){
                    value=0;
                }
                if (parseInt(value,10)>100){
                    value=100;
                }

                this.setState({
                    desiredSpikes: 100 - value,
                    desiredFriction:value
                });
                break;
            case "desiredSpikes":
                oldValue = parseInt(oldValue,10);
                if (!Number.isInteger(oldValue)){
                    oldValue=0;
                }

                value=parseInt(value,10);
                if (!Number.isInteger(value)){
                    value = oldValue;
                }
                if (parseInt(value,10)<0){
                    value=0;
                }
                if (parseInt(value,10)>100){
                    value=100;
                }
                this.setState({
                    desiredSpikes: value,
                    desiredFriction:100 - value
                });
                break;
            default:
                this.setState({
                    [event.target.name]: event.target.value
                });
                break;
        }
    }

    handleChangeGroupType = event => {
        this.setDefaultStationId();
        this.handleChange(event);
    }


    getGroupTypeIdByName(groupName){
        let x = null;
        for(x in this.props.groupTypes){
            if (this.props.groupTypes[x].name===groupName){
                return this.props.groupTypes[x].id;
            }
        }
        return null;
    }



    handleSubmit = (event) => {

        event.preventDefault();

        if (this.state.groupType !== 'Skiftesverkstad') {
            // Skicka till /api/station

            let type = typeof(this.state.groupType)==="object" ? this.state.groupType.id  : this.getGroupTypeIdByName(this.state.groupType);
            let data = {
                name: this.state.name,
                retailerId: this.state.retailerId,
                type: type,
                desiredSpikes: this.state.desiredSpikes,
                desiredFriction: this.state.desiredFriction
            };

            if (this.state.id){
                data.stationId = this.state.id;
                this.props.updateStation(data);
                if (typeof (this.props.onAccept)==="function"){
                    this.props.onAccept();
                }
            } else {
                this.props.createStation(data);
            }


        } else {
            // Skicka till /api/wheelchanger

            var sid = null;
            if (Number.isInteger(parseInt(this.state.stationId,10))){
                sid = this.state.stationId;
            } else {
                sid= this.state.stationId.id;
            }

            let data = {
                name: this.state.name,
                stationId: parseInt(sid, 10),
                retailerId: this.state.retailerId,
                address: this.state.address,
                postalCode: this.state.postalCode,
                city: this.state.city,
                phoneNumber: this.state.phoneNumber,
                email : this.state.email,
                deliverySchedule: this.state.deliverySchedule
            };

            if (this.state.id){
                data.id = this.state.id;
                this.props.updateWheelChanger(data);
                if (typeof (this.props.onAccept)==="function"){
                    this.props.onAccept();
                }
            } else {
                this.props.createWheelChanger(data);
            }

        }
    }


    setDefaultStationId(){
        if (this.props.groups.length>0 && !this.state.stationId){
            this.setState({
                stationId: this.props.groups[0].id
            });
        }
    }

    render() {
        let buttonTitle="Skapa grupp";
        if (this.state.id){
            buttonTitle="Uppdatera grupp";
        }

        let spikeFields= (
                <div>
                    <div className={"inputFieldWrapper"}>
                        <label htmlFor={"desiredFriction"}>Önskat antal friktion (0-100)</label>
                        <input
                            type="text"
                            name="desiredFriction"
                            id="desiredFriction"
                            placeholder="Önskat antal friktion (0-100)"
                            value={this.state.desiredFriction}
                            onChange={this.handleChange}
                            required
                        />
                    </div>

                    <div className={"inputFieldWrapper"}>
                        <label htmlFor={"desiredSpikes"}>Önskat antal dubb (0-100)</label>
                        <input
                            type="text"
                            name="desiredSpikes"
                            id="desiredSpikes"
                            placeholder="Önskat antal dubb (0-100)"
                            value={this.state.desiredSpikes}
                            onChange={this.handleChange}
                            required
                        />
                    </div>

                </div>
        );


        let addressFields = (

            <div>
                <div className={"inputFieldWrapper"}>
                    <label htmlFor={"stationId"}>Grupptyp</label>
                    <select
                        name="stationId"
                        id="stationId"
                        placeholder="Grupptyp"
                        onChange={this.handleChange}
                        value={this.state.stationId}
                    >
                        {typeof(this.props.groups)!=="undefined" &&
                        this.props.groups.length>0 &&
                        this.props.groups.map((group, key) => {
                            return (
                                <option key={key} value={group.id}>{group.name}</option>
                            )
                        })
                        }
                    </select>
                </div>



                <div className={"inputFieldWrapper"}>
                    <label htmlFor={"address"}>Adress</label>
                    <input
                        type="text"
                        name="address"
                        id="address"
                        placeholder="Adress"
                        value={this.state.address}
                        onChange={this.handleChange}
                        required
                    />
                </div>

                <div className={"inputFieldWrapper"}>
                    <label htmlFor={"city"}>Stad</label>
                    <input
                        type="text"
                        name="city"
                        id="city"
                        placeholder="Stad"
                        value={this.state.city}
                        onChange={this.handleChange}
                        required
                    />
                </div>

                <div className={"inputFieldWrapper"}>
                    <label htmlFor={"postalCode"}>Postnummer</label>
                    <input
                        type="text"
                        name="postalCode"
                        id="postalCode"
                        value={this.state.postalCode}
                        placeholder="Postnummer"
                        onChange={this.handleChange}
                        required
                    />
                </div>

                <div className={"inputFieldWrapper"}>
                    <label htmlFor={"phoneNumber"}>Telefonnummer</label>
                    <input
                        type="tel"
                        name="phoneNumber"
                        id="phoneNumber"
                        placeholder="Telefonnummer"
                        value={this.state.phoneNumber}
                        onChange={this.handleChange}
                        required
                    />
                </div>

                <div className={"inputFieldWrapper"}>
                    <label htmlFor={"email"}>Email</label>
                    <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Email"
                        value={this.state.email}
                        onChange={this.handleChange}
                        required
                    />
                </div>


                <div className={"inputFieldWrapper"}>
                    <label htmlFor={"deliverySchedule"}>Ledtid</label>
                    <select
                        name="deliverySchedule"
                        id="deliverySchedule"
                        value={this.state.deliverySchedule}
                        onChange={this.handleChange}
                        required
                    >
                        <option value={"0"}>Ledtid 0</option>
                        <option value={"1"}>Ledtid 1</option>
                        <option value={"2"}>Ledtid 2</option>
                        <option value={"3"}>Ledtid 3</option>
                    </select>
                </div>

            </div>
        );

        if (typeof(this.props.groupTypes)!=="undefined"){
            var options = this.props.groupTypes.map((groupType, key) => {
                if (groupType.name!=="Ingen"){
                    return (
                        <option
                            key={key}
                            id={groupType.id}
                            value={groupType.name}>
                            {groupType.name}
                        </option>
                    )
                }
                return null;

            });
        }


        const {submitting} = this.props;

        return (
            <div className='box create-user'>
                <div className='box-inner'>
                    <h2>{buttonTitle}</h2>
                    <Loading show={submitting} />
                    {!submitting &&

                    <form onSubmit={this.handleSubmit}>
                        <div className={"inputFieldWrapper"}>
                            <label htmlFor={"name"}>Namn</label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Namn"
                                onChange={this.handleChange}
                                required
                                value={this.state.name}
                            />
                        </div>


                        <div className={"inputFieldWrapper"}>
                            <label htmlFor={"retailerId"}>Id</label>
                            <input
                                type="text"
                                name="retailerId"
                                placeholder="Id"
                                onChange={this.handleChange}
                                required
                                //disabled={(this.state.id && (this.state.groupType!=="Skiftesverkstad" && this.state.groupType!=="Station"))}
                                value={this.state.retailerId}
                            />
                        </div>

                        <div className={"inputFieldWrapper"}>
                            <label htmlFor={"Grupptyp"}>Grupptyp</label>
                            <select
                                name="groupType"
                                placeholder="Grupptyp"
                                onChange={this.handleChangeGroupType}
                                value={this.state.groupType}
                                disabled={this.state.id}
                            >
                                {options}
                                <option id='5' value='Skiftesverkstad'>Skiftesverkstad</option>
                            </select>
                        </div>


                        {this.state.groupType === 'Skiftesverkstad' ? addressFields : spikeFields}


                        <input
                            type="submit"
                            disabled={!this.validateForm()}
                            className="submit creategroupsubmit form-submit"
                            value={buttonTitle}
                            onClick={(e)=> this.handleSubmit(e)}
                        />
                    </form>

                    }

                </div>
            </div>
        );
    }
}

/**
 * Map state to properties
 */
const mapStateToPropsForCreateGroup = (state) => {
    return {
        refresh: state.refresh,
        submitting: state.stations.submitting,
        groupTypes: state.stations.groupTypes,
        groups: state.stations.groups
    };
};

/**
 * Map actions to properties
 */
const mapDispatchToPropsForCreateGroup = (dispatch) => {
    return {
        setTrue: (key) => dispatch(setTrue(key)),
        createStation:(data) => dispatch(createStation(data)),
        createWheelChanger:(data) => dispatch(createWheelChanger(data)),
        getGroupTypes:()=>dispatch(getGroupTypes()),
        updateStation:(data) => dispatch(updateStation(data)),
        updateWheelChanger:(data) => dispatch(updateWheelChanger(data))
    };
};

/**
 * Create groups
 */
export default connect(mapStateToPropsForCreateGroup, mapDispatchToPropsForCreateGroup)(CreateGroupForm);



// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/CreateGroupForm.js